<template>
  <smd-one-col-layout class="modal-service-order-cancel">
    <text-string label-id="txt704" class="m-b-15"/>

    <div v-for="(reason, reasonIndex) in $options.cancellationReasons"
         :key="reasonIndex"
         class="smd-radio__row">
      <smd-radio v-model="selectedReason"
                 :label="getElementString(reason.labelId)"
                 :value="reason.labelId"/>
      <text-string v-if="reason.infoLabelId && selectedReason === reason.labelId"
                   :label-id="reason.infoLabelId"
                   class="reason-info m-t-5"/>
    </div>
    <div class="smd-radio__row">
      <smd-radio v-model="selectedReason"
                 :label="getElementString($options.otherCancellationReason)"
                 :value="$options.otherCancellationReason"/>
                 
      <div class="smd-form__row m-t-10">
        <smd-textarea v-if="selectedReason === $options.otherCancellationReason"
                      v-model="cancellationReason"
                      placeholder="What can we do to help us get better?"/>
      </div>
    </div>

    <div class="flex-row-center-x-spaced justify-content-center m-t-15">
      <smd-btn :disabled="loading"
               section="4"
               variant="unselected"
               @click="no">
        <text-string label-id="txt710"/>
      </smd-btn>
      <smd-btn :disabled="loading || cancellationReason === ''"
               section="4"
               variant="blue-enabled"
               @click="yes">
        <text-string label-id="txt711"/>
      </smd-btn>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import {mapActions} from 'vuex';
  import {
    ACTION_SET_MEDICINE_STATE,
  } from '@/store/types';
  import CloseModalMixin from '@/mixins/close-modal-mixin';
  import GetElementStringMixin from '@/mixins/get-element-string';
  import {MedicineService} from '@/services/medicine';
  import ToastMixin from '@/mixins/toast-mixin';

  export default {
    name: 'modal-service-order-cancel',
    mixins: [
      GetElementStringMixin,
      CloseModalMixin,
      ToastMixin,
    ],
    props: {
      orderid: {type: String, required: true},
    },
    data() {
      return {
        loading: false,
        selectedReason: null,
        cancellationReason: '',
      };
    },
    watch: {
      selectedReason(newValue) {
        this.cancellationReason = newValue === this.$options.otherCancellationReason
          ? ''
          : (this.getElementString(newValue) || 'No reason.');
      },
    },
    methods: {
      ...mapActions({
        setMedicineState: ACTION_SET_MEDICINE_STATE,
      }),
      no() {
        this.closeModal();
      },
      async yes() {
        this.loading = true;

        try {
          await MedicineService.cancelOrder(this.orderid, {cancelreason: this.cancellationReason});
          this.setMedicineState({
            needToReload: true,
          });
          this.closeModal({success: true});
        } catch (error) {
          this.showToast({
            text: 'Cancelling order failed. Please try again later.',
            theme: 'danger',
          });
        }
      },
    },
    cancellationReasons: [
      {
        labelId: 'txt716',
        infoLabelId: 'txt857',
      },
      {
        labelId: 'txt717',
        infoLabelId: 'txt858',
      },
      {
        labelId: 'txt718',
      },
      {
        labelId: 'txt719',
      },
    ],
    otherCancellationReason: 'txt720',
  }
</script>

<style lang="scss">
  .modal-service-order-cancel {
    .smd-radio__row {
      align-items: unset;
      flex-direction: column;

      .reason-info {
        @include border-radius(radius(small));
        padding: space(xs) space(s);
        background-color: rgba(255, 198, 14, 0.2);
      }
    }
  }
</style>
